import React, {forwardRef, useImperativeHandle, useRef} from 'react';
import GridContainer from "@/components/common/GridContainer";
import styled from "styled-components";
import {getCssSizeValue} from "@/utils/utils";
import {ScrollTrigger, useGSAP} from "@/utils/gsap";
import Info from "@/components/BranchNavigator/Info";
import Units from "@/components/BranchNavigator/Units";
import useScrollContext from "@/hooks/useScrollContext";
import ViewManager from "@/components/BranchNavigator/Desktop/ViewManager";
import DownloadFiles from "@/components/BranchNavigator/downloadFiles/DownloadFiles";
import {useNavigatorContext} from "@/components/BranchNavigator";


const Wrapper = styled(GridContainer)`
	border: solid 1px black;
`

const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	row-gap: var(--grid-gap);
	min-height: 85svh;
	--local-padding-x: ${getCssSizeValue(20)};
	position: relative;
    top: -1px;
`


const Navigator = forwardRef(function Navigator({ data }, fref){
	const WrapperRef = useRef()
	const ViewManagerRef = useRef()
	const mapDescription = data?.mapDescription || ''
	const { units, isLoading, isTextileCollection } = useNavigatorContext()
	const scroll = useScrollContext()

	useGSAP(() => {
		if(isTextileCollection) return
		ScrollTrigger.create({
			trigger: WrapperRef.current,
			pin: ViewManagerRef.current,
			pinSpacer: null,
			pinSpacing: false,
			start: 'top 12.5%',
			end: 'bottom 97.45%',
			invalidateOnRefresh: true
		})
		scroll.refresh()
	},{
		dependencies: [units, isLoading, isTextileCollection],
		revertOnUpdate: true
	})

	useImperativeHandle(fref, () => WrapperRef.current, [])

	return (
		<Wrapper ref={WrapperRef} className={`col-desktop-16 no-margin`} >
			<ViewManager ref={ViewManagerRef} description={mapDescription} />
			<Container className={`grid-12 col-desktop-12 no-margin`} >
				<Info data={data} className={`col-desktop-12`} />
				{!isTextileCollection ? <Units className={`col-desktop-12`}/> : <DownloadFiles className={`col-desktop-12`} />}
			</Container>
		</Wrapper>
	);
})

export default Navigator;


